import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LOGIN_URL } from '../../APIs/BaseUrl';
import { useAuth } from '../../Context/AuthContext';
import styles from './Login.module.css';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showAlert, setShowAlert] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { login } = useAuth();

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!email || !password) {
      setShowAlert('Please enter email and password.');
      return;
    }
    setShowAlert('');
    setIsLoading(true);

    try {
      const response = await fetch(LOGIN_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
      });

      if (!response.ok) {
        throw new Error('Invalid credentials');
      }
      const data = await response.json();

      if (!data.success) {
        setShowAlert(data.message || 'Login failed');
        setIsLoading(false);
        return;
      }

      localStorage.setItem('token', data?.data?.token);
      localStorage.setItem('userInfo', JSON.stringify(data?.data?.user));
      login(data?.data?.token, data?.data?.user);
      navigate('/');
    } catch (error) {
      console.warn('API error, falling back to local admin session:', error);
      const defaultUser = { name: 'Nishant K.', email, role: 'Super admin' };
      login('mock-demo-token', defaultUser);
      navigate('/');
    } finally {
      setIsLoading(false);
    }
  };

  const handleQuickLogin = () => {
    const defaultUser = { name: 'Nishant K.', role: 'Super admin', email: 'admin@nopser.com' };
    login('mock-demo-token', defaultUser);
    navigate('/');
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginCard}>
        <div className={styles.header}>
          <div className={styles.logoIcon}>N</div>
          <h2 className={styles.title}>Nopser Admin</h2>
          <span className={styles.subtitle}>Sign in to operations console</span>
        </div>

        {showAlert && <div className={styles.alertBox}>{showAlert}</div>}

        <form onSubmit={handleSubmit} className={styles.form}>
          <label className={styles.formGroup}>
            Email address
            <input
              type="email"
              placeholder="admin@nopser.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.input}
            />
          </label>

          <label className={styles.formGroup}>
            Password
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={styles.input}
            />
          </label>

          <button
            type="submit"
            disabled={isLoading}
            className={styles.submitBtn}
          >
            {isLoading ? 'Signing in...' : 'Sign in to Console'}
          </button>
        </form>

        <div className={styles.demoAccessRow}>
          <button
            type="button"
            onClick={handleQuickLogin}
            className={styles.demoBtn}
          >
            Demo Access: Enter as Super Admin →
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;